var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getTheme, Tenant } from '@finanzcheck/teal-mui-theme';
import { customTypographyVariantMapping, makeCustomTypographyStyleOverrides, } from './customTypography';
export var SMAVA_THEME_OPTIONS = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 500,
            md: 769,
            lg: 1024,
            xl: 1200,
        },
    },
    typography: {
        fontFamily: [
            'Roboto',
            '-apple-system',
            'BlinkMacSystemFont',
            'sans-serif',
        ].join(','),
    },
};
export var COMMON_THEME_OVERRIDES = {
    MuiFormHelperText: {
        styleOverrides: {
            contained: {
                paddingLeft: 0,
            },
        },
    },
    MuiButton: {
        styleOverrides: {
            root: {
                textTransform: 'inherit',
            },
        },
    },
    MuiAccordion: {
        styleOverrides: {
            root: {
                '& .MuiButton-Collapse-root': {
                    margin: 0,
                },
            },
        },
    },
    MuiCollapse: {
        styleOverrides: {
            root: {
                margin: 0,
            },
            entered: {
                margin: 0,
            },
        },
    },
};
export var SMAVA_THEME_OVERRIDES = function (theme) {
    var _a, _b, _c;
    return ({
        components: __assign(__assign({}, COMMON_THEME_OVERRIDES), { MuiLink: {
                styleOverrides: {
                    root: {
                        color: theme.palette.primary.main,
                        fontWeight: 700,
                    },
                },
            }, MuiTypography: {
                defaultProps: {
                    variantMapping: __assign({ body1: 'p', body2: 'p' }, customTypographyVariantMapping),
                },
                styleOverrides: __assign(__assign({ root: {
                        wordBreak: 'break-word',
                    } }, makeCustomTypographyStyleOverrides(theme)), { h1: (_a = {
                            margin: '0',
                            fontSize: '3rem',
                            lineHeight: '4rem',
                            fontWeight: 700,
                            color: theme.palette.text.primary
                        },
                        _a[theme.breakpoints.down('md')] = {
                            fontSize: '2.375rem',
                            lineHeight: '2.75rem',
                        },
                        _a), h2: (_b = {
                            margin: '0',
                            fontSize: '2rem',
                            lineHeight: '2.5rem',
                            fontWeight: 500,
                            color: theme.palette.text.primary
                        },
                        _b[theme.breakpoints.down('md')] = {
                            fontSize: '1.625rem',
                            lineHeight: '2.125rem',
                        },
                        _b), h3: {
                        margin: '0',
                        fontSize: '1.5rem',
                        lineHeight: '2rem',
                        fontWeight: 700,
                        color: theme.palette.text.primary,
                    }, h4: (_c = {
                            fontSize: '1.25rem',
                            lineHeight: '1.75rem',
                            fontWeight: 700,
                            color: theme.palette.text.primary
                        },
                        _c[theme.breakpoints.down('md')] = {
                            fontSize: '1.125rem',
                            lineHeight: '1.5rem',
                        },
                        _c), h5: {
                        fontSize: '1rem',
                        lineHeight: '1.375rem',
                        fontWeight: 500,
                        color: theme.palette.grey[900],
                    }, h6: {
                        fontSize: '0.875rem',
                        lineHeight: '1.25rem',
                        fontWeight: 500,
                        color: theme.palette.grey[900],
                    }, body1: {
                        fontSize: '1rem',
                        lineHeight: '1.5rem',
                        fontWeight: 400,
                        color: theme.palette.grey[900],
                        marginBottom: 0,
                    }, body2: {
                        fontSize: '0.875rem',
                        lineHeight: '1.25rem',
                        fontWeight: 400,
                        color: theme.palette.grey[900],
                        marginBottom: 0,
                    }, caption: {
                        fontSize: '0.75rem',
                        lineHeight: '1.25rem',
                        fontWeight: 400,
                        color: theme.palette.grey[900],
                        marginBottom: 0,
                    }, subtitle1: {
                        fontSize: '1rem',
                        lineHeight: '1.75rem',
                        fontWeight: 400,
                        color: theme.palette.grey[900],
                        marginBottom: 0,
                    }, subtitle2: {
                        fontSize: '0.875rem',
                        lineHeight: '1.375rem',
                        fontWeight: 500,
                        color: theme.palette.grey[900],
                        marginBottom: 0,
                    }, button: {
                        fontSize: '0.875rem',
                        lineHeight: '1.5rem',
                        fontWeight: 500,
                        color: theme.palette.grey[900],
                    }, overline: {
                        fontSize: '0.75rem',
                        lineHeight: '2rem',
                        fontWeight: 400,
                        color: theme.palette.grey[900],
                    } }),
            }, MuiRadio: {
                styleOverrides: {
                    colorSecondary: {
                        '&.Mui-checked': {
                            color: theme.palette.primary.main,
                        },
                    },
                },
            }, MuiDialogActions: {
                styleOverrides: {
                    root: {
                        '& .MuiButton-textPrimary': {
                            color: theme.palette.secondary.dark,
                        },
                    },
                },
            }, MuiSelect: {
                styleOverrides: {
                    select: {
                        paddingTop: 0,
                        paddingBottom: 0,
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        border: 'none',
                        '&:focus': {
                            backgroundColor: theme.palette.primary.contrastText,
                        },
                    },
                },
            }, MuiInputBase: {
                styleOverrides: {
                    root: {
                        '&:focus': {
                            backgroundColor: theme.palette.primary.contrastText,
                        },
                    },
                },
            }, MuiFormControl: {
                styleOverrides: {
                    root: {
                        marginBottom: 0,
                        marginTop: 0,
                    },
                },
            }, MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        '& input': {
                            height: '48px',
                            boxSizing: 'border-box',
                        },
                        '& textarea, & input': {
                            border: 'none',
                            color: theme.palette.grey[900],
                        },
                        '& textarea': {
                            resize: 'vertical',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: theme.palette.primary.main,
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            boxShadow: "0 0 2px ".concat(theme.palette.primary.main),
                        },
                        '&.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
                            boxShadow: "0 0 2px ".concat(theme.palette.error.main),
                        },
                        '& p.Mui-error': {
                            padding: '0',
                        },
                        '&.Mui-disabled': {
                            color: "".concat(theme.palette.grey[400]),
                            opacity: 0.6,
                            boxSizing: 'border-box',
                        },
                        '&.Mui-disabled .MuiInputAdornment-root': {
                            color: "".concat(theme.palette.grey[400]),
                        },
                    },
                    notchedOutline: {
                        borderWidth: '1px !important',
                    },
                },
            }, MuiInputAdornment: {
                styleOverrides: {
                    positionEnd: {
                        position: 'inherit',
                        paddingLeft: '8px',
                        right: '16px',
                        '& > p': {
                            marginBottom: '0 !important',
                        },
                    },
                },
            }, MuiFormLabel: {
                styleOverrides: {
                    root: {
                        '&.Mui-focused': {
                            color: theme.palette.grey[900],
                        },
                        '&.Mui-error': {
                            color: theme.palette.grey[900],
                        },
                    },
                },
            }, MuiAutocomplete: {
                styleOverrides: {
                    inputRoot: {
                        '& input': {
                            padding: "".concat(theme.spacing(0.5), " 0 ").concat(theme.spacing(0.5), " ").concat(theme.spacing(1), " !important"),
                        },
                    },
                },
            } }),
    });
};
export var theme = getTheme(Tenant.Smava, {
    options: SMAVA_THEME_OPTIONS,
    optionsWithThemeValues: SMAVA_THEME_OVERRIDES,
});
